<template>
  <v-menu
    v-model="isActive"
    offset-y
    transition="slide-y-transition"
    rounded="1"
    max-width="420"
    :nudge-top="-10"
    :close-on-content-click="false"
    content-class="filter__list mod--regions LKRoadmapsFeedFilterAte"
  >
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <FilterToggle
          title="Поиск по АТЕ:"
          :desc="selectedString"
          :active="isActive"
        />
      </div>
    </template>

    <div class="filter__form">
      <BAteTreeForm
        :regions.sync="regions"
        :municipalities.sync="municipalities"
        :schools.sync="schools"
        max-height="480px"
        model="Roadmap"
        :permission="userPermission"
        multiple
        class="filter__ate"
      >
        <template #search="{ attrs, on }">
          <div class="filter__form-box">
            <IconSearch
              :loading="attrs.loading"
              class="filter__search-icon"
            />

            <input
              :value="attrs.value"
              type="text"
              class="filter__form-input w-input"
              maxlength="256"
              autofocus
              placeholder="Регион или муниципалитет"
              @input="e => on.input(e.target.value)"
            >
          </div>
        </template>
      </BAteTreeForm>

      <div class="filter__button-container">
        <input value="Применить фильтры" class="filter__button w-button" @click.prevent="submit">
        <a class="filter__button-second w-inline-block cursor-pointer" @click="clear">
          <div class="text-md mod--filer-button">Сбросить все</div>
        </a>
      </div>
    </div>
  </v-menu>
</template>

<script>
import BAteTreeForm from '@/components/forms/BAteTree/BAteTreeForm.vue'
import IconSearch from '@/components/lk/icons/LKIconSearch.vue'
import FilterToggle from './LKRoadmapsFeedFilterToggle.vue'


export default {
  name: 'LKRoadmapsFeedFilterAte',
  inject: [
    'isAdresat',
    'isCurator',
  ],
  components: {
    BAteTreeForm,
    IconSearch,
    FilterToggle,
  },
  data: () => ({
    regions: [],
    municipalities: [],
    schools: [],
    isActive: false,
  }),
  computed: {
    selectedString() {
      const selected = []
      if (this.regions.length > 0) {
        selected.push(`Регионов: ${this.regions.length}`)
      }
      if (this.municipalities.length > 0) {
        selected.push(`Муниципалитетов: ${this.municipalities.length}`)
      }
      if (this.schools.length > 0) {
        selected.push(`ОО: ${this.schools.length}`)
      }
      return selected.length ? selected.join(', ') : 'Все'
    },
    userPermission() {
      if (this.isAdresat) return 'report'
      if (this.isCurator) return 'review'
      return 'read'
    },
  },
  created() {
    this.onInit()
  },
  methods: {
    onInit() {
      const { query } = this.$route
      let hasQuery = false

      if (query.region) {
        hasQuery = true
        const region = { id: query.region }
        this.regions.push(region)
      }

      if (query.municipality) {
        hasQuery = true
        const municipality = { id: query.municipality }
        this.municipalities.push(municipality)
      }

      if (query.school) {
        hasQuery = true
        const school = { id: query.school }
        this.schools.push(school)
      }

      if (hasQuery) {
        this.submit()
      }
    },
    submit() {
      this.isActive = false

      const data = {
        regions: [...this.regions],
        municipalities: [...this.municipalities],
        schools: [...this.schools],
      }

      this.$emit('submit', data)
    },
    clear() {
      this.regions = []
      this.municipalities = []
      this.schools = []
      this.submit()
    },
  },
}
</script>

<style lang="scss">
$light-blue: $webflow-color-blue-light;
$light-blue-hover: rgba($light-blue, 0.25);

$dark-blue: #49759d;
$btn-blue: $webflow-color-blue-dark-hover;
$btn-light-blue: $webflow-color-blue-dark;
$color-light-grey: $webflow-color-grey;

.LKRoadmapsFeedFilterAte {
  background: $color-white;

  .filter {
    &__form-box {
      display: flex;
      align-items: center;
    }

    &__search-icon {
      position: absolute;
      left: 12px !important;
    }

    &__ate {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 120px;

      > * {
        width: 100%;
      }
    }

    &__button {
      width: 200px;
      text-align: center;
    }

    &__form-input {
      padding-left: 44px;
    }
  }

  .v-list {
    $root: &;

    padding: 0;

    .v-input--selection-controls {
      padding-top: 0;
      margin-top: 0;
    }

    .v-input--selection-controls__input {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $light-blue;
      transform: scale(0.7);

      .mdi-checkbox-blank-outline {
        color: transparent !important;
      }

      .mdi-checkbox-marked {
        width: 12px;
        height: 12px;
        background: $dark-blue;

        &::before {
          content: "";
        }
      }
    }

    .v-input--is-disabled .v-input--selection-controls__input {
      background: transparent;

      .v-icon {
        color: transparent !important;
      }
    }

    .v-input--is-disabled.v-input--indeterminate {
      .v-icon {
        color: rgba($dark-blue, 0.5) !important;
      }
    }

    &-group__items {
      margin-left: 24px;
    }

    &-item {
      &:hover {
        background-color: $light-blue-hover;
      }

      &:hover::before {
        content: none;
      }

      &__icon {
        margin-right: 4px !important;
        margin-left: 4px !important;
      }
    }
  }

  .b-ate-tree-form {
    &__top {
      padding: 0;
    }

    &__checkbox {
      display: none;
    }

    &__message-empty {
      margin: 10px 20px;
    }

    &-recursive {
      border-bottom: 1px solid $light-blue;

      &:last-child {
        border-bottom-style: none;
      }
    }
  }
}
</style>
